import { useState, React , useEffect} from 'react';
import { useEthers } from '@usedapp/core';
import "./Styles.css"
import Right from './components/Right';
import Left from './components/Left';
import { formatEther } from '@ethersproject/units'
import { ToastContainer } from 'react-toastify';
import DisplayBanner from './components/DisplayBanner';
import { MOONBASE_ADDRESS, MOONBEAM_ADDRESS } from './constants';
import metamask from './assets/metamask_logo.png';

const App = () => {

  const { activateBrowserWallet, account , chainId, deactivate} = useEthers();
  const isConnected = account !== undefined;

  const moonbase_a_vip = MOONBASE_ADDRESS;
  const moonbeam_vip = MOONBEAM_ADDRESS;

  let curr_address = moonbeam_vip;

  if(chainId == '1287') {
    curr_address = moonbase_a_vip;
  }
  else if(chainId == '1284') {
    curr_address = moonbeam_vip;
  }

  const [ displayPage, setDisplayPage ] = useState(false);

  useEffect(() => {
    if(!window.ethereum) {
      setDisplayPage(false);
    }
    else {
      setDisplayPage(true);
    }
  }, [window.ethereum]);

  try {
  } catch (err) {
    console.log(err);
  }

  const [ displayAdmin, setDisplayAdmin ] = useState(false);
  const [ displayBanner, setDisplayBanner ] = useState(false);

  const adminClickHandler = (data) => {
    setDisplayAdmin(data);
    // console.log(data);
  }

  useEffect(() => {
    if(window.ethereum) {
      window.ethereum.on('accountsChanged', function (accounts) {
        window.location.reload(true);
      })
    }
  });

  // console.log(vip); 

  return (
    displayPage ? 
    <div className="bg">
      <DisplayBanner displayBanner={displayBanner}></DisplayBanner>
      <ToastContainer
        position="top-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnHover
        theme="dark"
      />
      <Left onAdmin = {adminClickHandler} displayAdmin = {displayAdmin} account = {account}></Left>
      <Right activateBrowserWallet={activateBrowserWallet} account={account} deactivate={deactivate} chainId={chainId} displayAdmin={displayAdmin} setDisplayBanner={setDisplayBanner} curr_address={curr_address}></Right>
    </div>
    : 
    <div className="not-connected">
      <div className="not-connected-button" onClick={() => { window.open('https://metamask.io/', '_blank') }}>
        <img src={metamask} alt='Metamask Logo' className='not-connected-image'/>
        <div className="not-connected-text">Install Metamask to continue</div>
      </div>
    </div>
  )
}

export default App